module.exports = __webpack_public_path__ + "static/media/ic-fix-broken.14db948b.svg";